import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, permiso }) => {
  const { isAuthenticated, loading, tienePermiso } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <p className="text-muted">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar permiso si se especificó
  if (permiso && !tienePermiso(permiso)) {
    return (
      <div className="text-center py-5">
        <i className="bi bi-shield-exclamation text-warning" style={{ fontSize: '3rem' }}></i>
        <h4 className="mt-3">Sin permisos</h4>
        <p className="text-muted">No tienes permisos para acceder a esta sección.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
